import { UnsupportedChainIdError, useWeb3React } from '@web3-react/core'
import { useModal, useWalletModal } from '@pancakeswap/uikit'
import { ClipboardDocumentIcon, WalletIcon } from '@heroicons/react/24/outline'
import useAuth from 'hooks/useAuth'
import { useTranslation } from 'contexts/Localization'
import { usePendingTransactions } from 'state/transactions/hooks'
import WalletModal, { WalletView } from './WalletModal'

/** Wallet action in the persistent bottom navigation. */
const UserMenu = () => {
  const { t } = useTranslation()
  const { account, error } = useWeb3React()
  const { login, logout } = useAuth()
  const { hasPendingTransactions } = usePendingTransactions()
  const { onPresentConnectModal } = useWalletModal(login, logout, t)
  const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO} />)
  const [onPresentWrongNetworkModal] = useModal(<WalletModal initialView={WalletView.WRONG_NETWORK} />)
  const isWrongNetwork = error instanceof UnsupportedChainIdError
  const label = account ? `${account.slice(0, 6)}…${account.slice(-4)}` : t('Connect Wallet')

  const handleClick = () => {
    if (isWrongNetwork) {
      onPresentWrongNetworkModal()
    } else if (account) {
      onPresentWalletModal()
    } else {
      onPresentConnectModal()
    }
  }

  return (
    <button
      type="button"
      data-testid="bottom-wallet"
      onClick={handleClick}
      title={account || t('Connect Wallet')}
      aria-label={account ? `${t('Your Wallet')}: ${account}` : t('Connect Wallet')}
      className="relative flex h-full min-w-0 w-full flex-col items-center justify-center gap-0.5 bg-gradient-to-b from-orange-700 to-orange-800 px-1 py-1 text-white transition-colors hover:from-orange-600 hover:to-orange-700 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-amber-300"
    >
      <span className="flex items-center gap-1" aria-hidden="true">
        <ClipboardDocumentIcon className="h-4 w-4 text-amber-400" />
        <WalletIcon className="h-4 w-4" />
        {hasPendingTransactions && <span className="h-1.5 w-1.5 rounded-full bg-amber-300" />}
      </span>
      <span className="max-w-full truncate text-[10px] font-medium sm:text-xs">
        {isWrongNetwork ? t('Network') : label}
      </span>
    </button>
  )
}

export default UserMenu
